<router-outlet></router-outlet>

@if (inAppNotificationService.current(); as inAppNotification) {
	<div class="in-app-snackbar" role="status" aria-live="polite">
		<button
			type="button"
			class="in-app-snackbar__content"
			(click)="openInAppNotification()"
		>
			<span class="in-app-snackbar__title">
				{{ inAppNotification.title || ('common.notifications.new_push_title' | translate) }}
			</span>
			@if (inAppNotification.body) {
				<span class="in-app-snackbar__body">{{ inAppNotification.body }}</span>
			} @else {
				<span class="in-app-snackbar__body">
					{{ 'common.notifications.open_message' | translate }}
				</span>
			}
		</button>

		<button
			type="button"
			class="in-app-snackbar__close"
			(click)="inAppNotificationService.dismiss()"
			[attr.aria-label]="'common.buttons.close' | translate"
		>
			×
		</button>
	</div>
}

